export default __webpack_public_path__ + "images/femur_blue.8b4e48cceb129d0314b164cd3bbb4874.png";